/*
* Copyright (C) Regione Lombardia
*/
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { AnagraficaService } from '@shared/services/anagrafica.service';
import { OperaService } from '@shared/services/opera.service';
import { PermessiService } from '@shared/services/permessi.service';
import { forkJoin, map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PagesGestioneOperaDettaglioOperaResolver implements Resolve<Observable<any>> {

    constructor(
        private anagraficaService: AnagraficaService,
        private operaService: OperaService,
        private permessiService: PermessiService,
    ) { }

    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        return forkJoin([
            this.anagraficaService.getClasseDocumento(),
            this.anagraficaService.getComuni(),
            this.anagraficaService.getClassificazioneOpera(),
            this.anagraficaService.getFascePercentuali(),
            this.anagraficaService.getImportanzaOpera(),
            this.anagraficaService.getMacroTipologiaOpera(),
            this.anagraficaService.getMateriale(),
            // this.anagraficaService.getProvenienza(),
            this.anagraficaService.getProvince(),
            this.anagraficaService.getSponda(),
            this.anagraficaService.getStatoOpera(),
            this.anagraficaService.getTipologiaIntervento(),
            this.anagraficaService.getTipologiaInterventoNew(),
            this.anagraficaService.getTipologiaOpera(),
            this.anagraficaService.getTipoShape(),
            this.anagraficaService.getEvento(),
            this.anagraficaService.getFonte(),
            this.anagraficaService.getTipologiaRilevamento(),
            this.anagraficaService.getFunzionePrevalente(),
            this.operaService.read(route.params['idOpera']),
            this.operaService.documentoOperaByIdOpera(route.params['idOpera']),
            this.operaService.manutenzioneByIdOpera(route.params['idOpera']),
            this.operaService.monitoraggioByIdOpera(route.params['idOpera']),
            this.operaService.operaSecondariaByIdOpera(route.params['idOpera']),
            this.operaService.pianoInterventiByIdOpera(route.params['idOpera']),
            this.operaService.rilevamentoByIdOpera(route.params['idOpera']),
            this.operaService.monitoraggiSopralluoghiByIdOpera(route.params['idOpera']),
        ]).pipe(
            map(([
                responseAnagraficaClasseDocumento,
                responseAnagraficaComuni,
                responseAnagraficaClassificazioneOpera,
                responseAnagraficaFascePercentuali,
                responseAnagraficaImportanzaOpera,
                responseAnagraficaMacroTipologiaOpera,
                responseAnagraficaMateriale,
                // responseAnagraficaProvenienza,
                responseAnagraficaProvince,
                responseAnagraficaSponda,
                responseAnagraficaStatoOpera,
                responseAnagraficaTipologiaIntervento,
                responseAnagraficaTipologiaInterventoNew,
                responseAnagraficaTipologiaOpera,
                responseAnagraficaTipoShape,
                responseAnagraficaEvento,
                responseAnagraficaFonte,
                responseAnagraficaTipologiaRilevamento,
                responseAnagraficaFunzionePrevalente,
                responseOpera,
                responseDocumentoOperaByIdOpera,
                responseManutenzioneByIdOpera,
                responseMonitoraggioByIdOpera,
                responseOperaSecondariaByIdOpera,
                responsePianoInterventiByIdOpera,
                responseRilevamentoByIdOpera,
                responseMonitoraggiSopralluoghiByIdOpera
            ]) => {
                this.operaService.operaSession = responseOpera;
                this.permessiService.initPermessiOpera();
                return {
                    opera: responseOpera,
                    documentoOpera: responseDocumentoOperaByIdOpera,
                    manutenzione: responseManutenzioneByIdOpera,
                    monitoraggio: responseMonitoraggioByIdOpera,
                    operaSecondaria: responseOperaSecondariaByIdOpera,
                    pianoInterventi: responsePianoInterventiByIdOpera,
                    rilevamento: responseRilevamentoByIdOpera,
                    monitoraggiSopralluoghi: responseMonitoraggiSopralluoghiByIdOpera,
                    datalist: {
                        classeDocumento: responseAnagraficaClasseDocumento,
                        comuni: responseAnagraficaComuni,
                        classificazioneOpera: responseAnagraficaClassificazioneOpera,
                        fascePercentuali: responseAnagraficaFascePercentuali,
                        importanzaOpera: responseAnagraficaImportanzaOpera,
                        macroTipologiaOpera: responseAnagraficaMacroTipologiaOpera,
                        materiale: responseAnagraficaMateriale,
                        // provenienza: responseAnagraficaProvenienza,
                        province: responseAnagraficaProvince,
                        sponda: responseAnagraficaSponda,
                        statoOpera: responseAnagraficaStatoOpera,
                        tipologiaIntervento: responseAnagraficaTipologiaIntervento,
                        tipologiaOpera: responseAnagraficaTipologiaOpera,
                        tipoShape: responseAnagraficaTipoShape,
                        tipologiaRilevamento: responseAnagraficaTipologiaRilevamento,
                        tipologiaInterventoNew: responseAnagraficaTipologiaInterventoNew,
                        evento: responseAnagraficaEvento,
                        fonte: responseAnagraficaFonte,
                        funzionePrevalente: responseAnagraficaFunzionePrevalente,
                    },
                };
            }),
        );
    }

}